import { render, staticRenderFns } from "./DataCorrectionPopupDetails.vue?vue&type=template&id=01e60038&scoped=true&"
import script from "./DataCorrectionPopupDetails.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionPopupDetails.vue?vue&type=style&index=0&id=01e60038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e60038",
  null
  
)

export default component.exports